import "./ChartIQPeriodicityComponent.scss";
import {ChartIQComponentController} from "../chart/ChartIQComponent";
import {ChartPeriod, ONE_DAY, Periods, periodsMatch} from "./Periods";
import {IOnDestroy, IOnInit, ITimeoutService} from "angular";
import {ChartIQPeriodicity} from "../../types/ChartIQ";
import "rxjs/add/operator/first";
import {Subject} from "rxjs/Subject";
import {Observable} from "rxjs/Observable";
import {ComponentCallback} from "../../../../types/AngularJS";

export const TfIqPeriod = "tfIqPeriod";

export function tfIqPeriod() {
    return {
        templateUrl: "app/components/chartiq/components/chart-periodicity/ChartIQPeriodicityComponent.html",
        bindings: {
            onChange: "&"
        },
        require: {
            chart: "^^tfIqChart"
        },
        controller: ChartIQRangePeriodicityController,
        controllerAs: "ctrl"
    };
}

export class ChartIQRangePeriodicityController implements IOnInit, IOnDestroy {

    /** @output */
    public readonly onChange: ComponentCallback;

    /** @require */
    public readonly chart: ChartIQComponentController;

    public periods = Periods;
    public currentPeriod?: ChartPeriod = ONE_DAY;
    private destroy$ = new Subject<void>();

    /** @ngInject */
    public constructor(private $timeout: ITimeoutService) {

    }

    public $onInit() {
        const created = this.chart.created$;
        const layout = this.chart.layout();
        Observable.merge(created, layout)
                  .takeUntil(this.destroy$)
                  .map(() => this.chart.currentPeriod())
                  .subscribe((chartPeriod) => {
                      const period = this.periods.find((p) => periodsMatch(p.data, chartPeriod));
                      this.$timeout(() => this.currentPeriod = period);
                  });
    }

    public selectPeriod(newPeriodicity: ChartIQPeriodicity) {
        this.chart.setPeriod(newPeriodicity);
        this.currentPeriod = this.periods.find(period => periodsMatch(period.data, newPeriodicity));
        this.onChange({period: newPeriodicity});
    }

    public $onDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
